module.exports = __webpack_public_path__ + "baafd7d7fc1b69642270c1c1fee58bed.svg";